'use client';

import { Box, Button, Flex } from '@radix-ui/themes';
import { AnimatePresence, motion } from 'framer-motion';
import { useRef } from 'react';
import { notoSerif } from '@/app/ui/fonts';
import MarkdownExtended from '@/app/ui/markdown/markdown-extended';
import Link from 'next/link';

interface Props {
  markdown: string;
  showAnswer: boolean;
  onToggleAnswer: () => void;
  solutionUrl: string;
  onBeforeNavigateToSolution: () => void;
}

const CardFooterView = ({
  markdown,
  showAnswer,
  onToggleAnswer,
  solutionUrl,
  onBeforeNavigateToSolution
}: Props) => {
  const contentRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Flex
        justify='center'
        align='center'
        gap='4rem'
        pt='2'
      >
        <Button
          variant='ghost'
          onClick={onToggleAnswer}
          color='gray'
        >
          {showAnswer ? 'Скрыть' : 'Показать'} ответ
        </Button>

        <Button
          variant='ghost'
          onClick={onBeforeNavigateToSolution}
          color='gray'
          asChild
        >
          <Link
            href={solutionUrl}
            passHref
          >
            Показать решение
          </Link>
        </Button>
      </Flex>
      <AnimatePresence>
        <motion.div
          ref={contentRef}
          initial={{ height: 0 }}
          animate={{
            height: showAnswer ? contentRef.current?.scrollHeight : 0
          }}
          exit={{ height: 0 }}
          transition={{ ease: [0.25, 0.1, 0.25, 1], duration: 0.5 }}
          style={{ overflow: 'hidden' }}
        >
          <div className={notoSerif.className}>
            <Box p='4'>
              <MarkdownExtended markdown={markdown} />
            </Box>
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};
export default CardFooterView;
